// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__3e7La","--sm":"Avatar_--sm__1mDyJ","--md":"Avatar_--md__3mDwC"};